import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";

import { getWorklogHistory } from "../../../../sevices/apiWorklog";
import { CustomButton } from "../../../../components/Button/Button";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";

function Download({ byTask = false }) {
  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );
  const { id } = useBoardIdByKey();
  const [searchParams] = useSearchParams();
  const user = searchParams
    .get("search")
    ?.split(",")
    ?.map((user) => ({ user_id: user }))
  // const user = useMemo(
  //   () => groupingUser.map((item) => item?.users).flat(),
  //   [groupingUser]
  // );
  const checkedList = useSelector((state) => state.search.boardSearch);
  const dateRange = useSelector((state) => state.search.dateRange);
  const epicSearch = useSelector((state) => state.search.epicSearch);

  const downloadCsv = useCallback(() => {
    getWorklogHistory(
      user,
      checkedList.length > 0 ? checkedList.length : [id],
      dateRange,
      epicSearch,
      true,
      byTask
    )
      .then(async (response) => {
        const text = response.data;
        const blob = new Blob([text], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "worklog.csv"; // Set the desired file name here
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user, checkedList, dateRange, epicSearch, byTask, id]);
  return (
    <CustomButton
      variant="contained"
      className="see-worklogs"
      onClick={downloadCsv}>
      Download Worklogs
    </CustomButton>
  );
}

export default Download;
